<template>
  <div>
  <!-- footer -->
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-lg-3 download">
            <div class="row">
              <!-- <div class="global_qrcode">
                  <img id="imgggg" src="@/assets/images/global_qrcode.png" alt="下載QRcode">
              </div> -->
              <div  v-if="$store.state.breadcrumb[1].name != '首頁' " class="global_qrcode" >
              </div>
              <div  v-else class="global_qrcode" >
                <img src="@/assets/images/global_qrcode.png" alt="下載QRcode">
              </div>
              <div class="appIcon">
                  <img src="@/assets/images/appicon.png" alt="一刻鯨選">
              </div>
              <!-- <div class="stores">
                  <a href=""><img src="@/assets/images/appstore.png" title="從 App Store 下載"></a>
                  <a href=""><img src="@/assets/images/googleplay.png" title="從 Google Play 下載"></a>
              </div> -->
              <div class="stores">
                <a href="https://itunes.apple.com/tw/app/id1440248584?l=zh&mt=8" target="_blank" ><img src="@/assets/images/appstore.png" title="從 App Store 下載"></a>
                <!--ios上架後移除 start-->
                <p style="font-size: 12px; color: #fff; margin: 0;"><br></p>
                <!-- <style type="text/css">footer .stores >a:first-child{margin-bottom: 0;}</style> -->
                <!--ios上架後移除 end-->
                <a href="https://play.google.com/store/apps/details?id=net.jinfm.app"  target="_blank" ><img src="@/assets/images/googleplay.png" title="從 Google Play 下載"></a>
              </div>
            </div>
          </div>
          <div class="col-md-8 col-lg-9">
              <!-- <ul class="lan">
                  <li :class="{'current':$store.state.lang == 'zh-TW'}"><a class="btnStyle_1" @click="changeLang('zh-TW')" >繁體中文</a></li>
                  <li :class="{'current':$store.state.lang == 'zh-CN'}"><a class="btnStyle_1" @click="changeLang('zh-CN')" >簡体中文</a></li>
              </ul> -->
              <ul class="links">
                <li><router-link to="/news/list"><a href="/news/list">{{$t("news")}}</a></router-link></li>
                <li><router-link to="/terms"><a href="/terms">{{$t("Terms of Service")}}</a></router-link></li>
                <li><a href="https://www.udngroup.com/members/udn_privacy" target="_blank">{{$t("Privacy Notice")}}</a></li>
                <li><router-link to="/help"><a href="/help">{{$t("Frequently Asked Questions")}}</a></router-link></li>
                <li> <router-link to="/contact"><a href="/contact">{{$t("Contact Us")}}</a></router-link></li>
              </ul>

              <p class="copyR">聯合報系 著作權所有 © udngroup.com. All Rights Reserved.</p>
          </div>
        </div>

        <div id="bottomsheet" class="bottomsheet">
          <a class="downloadbtn animated slideInUp" v-bind:href="shareUrl" target="_blank"  @click="gaClick ('smart banner','下載 App')"  >立即下載 App</a>
        </div>

        <div id="pagetop">
          <p class="animated slideInUp" title="top">top</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  data () {
    return {
      shareUrl: ''
    }
  },
  created () {
    this.pageUrl = window.location.toString()
    if (this.pageUrl.includes('testfront')) {
      this.shareUrl = 'https://jinfm.page.link/?link=https://testfront.jinfm.net/&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm&st=一刻鯨選&sd=好知識就在耳邊'
    } else {
      this.shareUrl = 'https://jinfm.page.link/?link=https://jinfm.net&apn=net.jinfm.app&isi=1440248584&ibi=net.jinfm.app&ius=jinfm&st=一刻鯨選&sd=好知識就在耳邊'
    }
  },
  methods: {
    gaClick (action, title) {
      this.$ga.event({
        eventCategory: '行銷',
        eventAction: action,
        eventLabel: title
        // eventValue: 123
      })
    },
    changeLang (local) {
      this.$store.dispatch('setLang', local)
    }
  },
  mounted () {
    // var documentHeight = $(document).height()
    // var windowHeight = $(window).height()
    // var fromBot = documentHeight - 300 - windowHeight

    // if ($( window ).width() <= 1024) {
    //     $(window).scroll(function(){
    //         var windowScrollTop = $(document).scrollTop();

    //         if(windowScrollTop > 200 && windowScrollTop < fromBot) {
    //         $("#bottomsheet").fadeIn('show');
    //         } else if(windowScrollTop > fromBot) {
    //         $("#bottomsheet").fadeOut('show');
    //         } else if(windowScrollTop < 200) {
    //         $("#bottomsheet").fadeOut('show');
    //         };
    //     });
    //  };

    //      $(window).scroll(function () {
    //     var s = $(this).scrollTop();
    //     var m = 300;
    //     if(s > m) {
    //         $("#pagetop,#bottomsheet").fadeIn('slow');
    //     } else if(s < m) {
    //         $("#pagetop,#bottomsheet").fadeOut('slow');
    //     };

    // });

    // $("#pagetop p").click(function () {
    //     $('html,body').animate({ scrollTop: 0 }, 'slow');
    //     return false;
    // });
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/subViews/Footer.vue